import { ReactElement } from 'react';
import {
  HeaderLinksSt,
  IndentedLinkSt,
  HeaderLinksTitle,
  IndentedLinksSt,
} from './TableOfContents.css';
import { ButtonLink } from 'app/shared/components/ButtonLink/ButtonLink';
import Translation from 'app/shared/components/Translation/Translation';

export interface ITableOfContentsSection {
  heading: string;
  headingLevel: 2 | 3 | 4 | 5 | 6;
  sectionSlug: string;
}

export interface ITableOfContentsProps {
  items: ITableOfContentsSection[];
}

const TableOfContents = ({ items }: ITableOfContentsProps): ReactElement => {
  const minHeadingLevel = items.reduce(
    (cur, res) => Math.min(cur, res.headingLevel),
    6,
  );

  return !items.length ? null : (
    <HeaderLinksSt>
      <HeaderLinksTitle>
        <Translation
          id="shared.components.contentful.blocks.toc.headerlinks.title"
          defaultMessage="In this guide"
        />
      </HeaderLinksTitle>
      <IndentedLinksSt>
        {items.map(i => (
          <IndentedLinkSt
            key={i.sectionSlug}
            indentLevel={i.headingLevel - minHeadingLevel}
          >
            <ButtonLink href={`#${i.sectionSlug}`}>{i.heading}</ButtonLink>
          </IndentedLinkSt>
        ))}
      </IndentedLinksSt>
    </HeaderLinksSt>
  );
};

export default TableOfContents;
